import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {Program} from "../scratchpad-ui.tsx";

import type {
    createProgram as createProgramResult,
    createProgramVariables,
} from "./__graphql-types__/createProgram.ts";
import {mapToProgram} from "./gql-type-mappers.ts";
import {PROGRAM_FRAGMENT} from "./program-fragment.ts";

export const CREATE_PROGRAM: GqlOperation<
    createProgramResult,
    createProgramVariables
> = gqlOp(gql`
    mutation createProgram(
        $title: String!
        $userAuthoredContentType: UserAuthoredContentType!
        $revision: ProgramRevisionInput!
        $curationNodeSlug: String!
    ) {
        createProgram(
            title: $title
            userAuthoredContentType: $userAuthoredContentType
            revision: $revision
            curationNodeSlug: $curationNodeSlug
        ) {
            program {
                ...Program
            }
            error {
                code
                debugMessage
            }
        }
    }
    ${PROGRAM_FRAGMENT}
`);

export const createProgram = async (
    gqlFetch: GqlFetchFn,
    variables: createProgramVariables,
): Promise<Program> => {
    const result = await gqlFetch(CREATE_PROGRAM, {variables});
    const program = result.createProgram?.program;
    if (!program) {
        throw new KAError("Failed to create program", Errors.Internal);
    }
    return mapToProgram(program);
};
